<template>
 <div>
   <router-link :to="productPageLink">
     <product-image class="product-image__content"
                    :image="thumbnailObj"
                    :alt="product.name | htmlDecode"
                    data-testid="productImage"
     />
   </router-link>
   <div class="center-md center-xs">
     <p class="mb10 pointer" @click="goProductPage">{{ $t(product.name) }}</p>
     <div class="flex mb10">
       <base-input-number :name="$t('Quantity')"
                          class="gift-box-qty col-md-6 col-xs-6"
                          v-model="product.qty"
                          :min="product.stock.min_sale_qty"
                          :qty="product.stock.qty"
                          :sku="product.sku"
                          :qty-in-cart="qtyInCart"
                          :validations="[
                            {
                              condition: $v.product.qty.$error && !$v.product.qty.minValue,
                              text: $t('Quantity must be above 0')
                            }
                          ]"
                          @input="updateQuantity($event, product.stock.is_qty_decimal)"
       />
       <span class="weight-700 center-self col-md-6 col-xs-6">{{ product.price * product.qty | price }}</span>
     </div>
     <add-to-cart
       :product="product"
       :disabled="$v.product.qty.$error && !$v.product.qty.minValue"
       class="col-xs-12 col-sm-12 col-md-12 gift-block-button-add-to-cart"
     />
     <div class="pointer gift-show-description" @click="showDescription = !showDescription">{{ showDescription ? $t('Hide the composition of the goods') : $t('View the composition of the goods') }}</div>
   </div>
   <div v-if="showDescription" v-html="$t(product.description)"/>
 </div>
</template>

<script>
import ProductImage from "../core/ProductImage";
import { ProductTile } from '@vue-storefront/core/modules/catalog/components/ProductTile.ts'
import BaseInputNumber from "../core/blocks/Form/BaseInputNumber";
import AddToCart from "../core/AddToCart";
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { formatProductLink } from '@vue-storefront/core/modules/url/helpers'
import { minValue } from 'vuelidate/lib/validators'
import config from 'config'
export default {
  name: "GiftsBoxProduct",
  props: {
    product: {
      type: Object
    }
  },
  components: {
    ProductImage,
    BaseInputNumber,
    AddToCart
  },
  mixins: [ProductTile],
  data () {
    return {
      showDescription: false
    }
  },
  validations: {
    product: {
      qty: {
        minValue: minValue(config.restrictions.productMinQty.isDecimal)
      }
    }
  },
  computed: {
    qtyInCart () {
      if (this.cartItem) {
        return parseFloat(this.cartItem.qty).toFixed(2)
      }
    },
    cartItem () {
      return this.$store.getters['cart/getCartItems'].find(item => item.entity_id === this.product.entity_id)
    },
    productPageLink () {
      return formatProductLink(this.product, currentStoreView().storeCode, this.$store.getters['partners/getCurrentPartner'].code, this.$route.params.locationCode)
    }
  },
  methods: {
    updateQuantity () {
      this.$forceUpdate();
    },
    goProductPage () {
      this.$router.push(this.productPageLink);
    }
  }
}
</script>

<style lang="scss" scoped>
  .gift-show-description {
    color: #11bb2e;
    margin-top: 5px;
  }
  .mb5 {
    margin-bottom: 5px;
  }
  .gift-block-button-add-to-cart {
    padding: 10px;
  }
</style>
<style lang="scss">
  .gift-box-qty {
    div {
      justify-content: center;
    }
  }
</style>
